// GANZ OBEN, VOR ALLEN ANDEREN IMPORTEN.
// Leitet im Übernahme-Tab die Supabase-Auth-Schlüssel in den sessionStorage um,
// bevor der Supabase-Client gebaut wird. Wird diese Zeile verschoben, fliegt der
// Admin bei jeder Übernahme aus seinem eigenen Konto.
import "./lib/uebernahme-speicher";

import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// App entry point – v2
createRoot(document.getElementById("root")!).render(<App />);
